export enum LoadingStatus {
    LOADING,
    LOADED,
}
